module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "rt-search"
  }, [(_vm.showSearch) ? _c('el-input', _vm._b({
    attrs: {
      "value": _vm.value,
      "placeholder": _vm.placeholder
    },
    on: {
      "input": _vm.inputHander
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.enterHander($event)
      }
    }
  }, 'el-input', _vm.$attrs, false), [_c('rt-icon', {
    attrs: {
      "slot": "suffix",
      "name": "rt-base-lookup"
    },
    on: {
      "click": _vm.onSearch
    },
    slot: "suffix"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.more) ? _c('div', {
    staticClass: "rt-search-more",
    on: {
      "click": _vm.onMore
    }
  }, [_c('rt-button', {
    attrs: {
      "suffix-icon": _vm.suffixIcon,
      "type": "plain",
      "text": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$tx('更多筛选', 'xpc.search.more')) + "\n    ")])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c86abf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-xpc/src/components/search/rtSearch.vue
// module id = 1469
// module chunks = 91